import accountService from '../services/AccountService';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const no401redirectAttribute = 'no401redirect';

export const onLogin = ({email, password}) => async (dispatch) => {
    dispatch({type: LOGIN_REQUEST});

    try {
        const user = await accountService.login(email, password);
        return dispatch({type: LOGIN_SUCCESS, user});
    } catch (error) {
        if (error.response && error.response.data) {
            return dispatch({type: LOGIN_FAILURE, error: error.response.data});
        }
        return dispatch({type: LOGIN_FAILURE, error});
    }
};

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const onLogout = () => async (dispatch) => {
    dispatch({type: LOGOUT_REQUEST});
    try {
        await accountService.logout();
        return dispatch({type: LOGOUT_SUCCESS});
    } catch (error) {
        console.error(error);
        return dispatch({type: LOGOUT_FAILURE, error, [no401redirectAttribute]: true});
    }
};

export const REGISTER_CAPTCHA_RESPONSE = 'REGISTER_CAPTCHA_RESPONSE';

export const onCaptchaResponse = (captchaResponse) => {
    return {type: REGISTER_CAPTCHA_RESPONSE, captchaResponse};
};

export const REGISTER_TOGGLE_AGREE_SERVICE_TERMS = 'REGISTER_TOGGLE_AGREE_SERVICE_TERMS';

export const onToggleAgreeServiceTerms = () => {
    return {type: REGISTER_TOGGLE_AGREE_SERVICE_TERMS};
};

export const REGISTER_SUBMIT_REQUEST = 'REGISTER_SUBMIT_REQUEST';
export const REGISTER_SUBMIT_SUCCESS = 'REGISTER_SUBMIT_SUCCESS';
export const REGISTER_SUBMIT_FAILURE = 'REGISTER_SUBMIT_FAILURE';

export const onRegister = (data, history) => async (dispatch) => {
    dispatch({type: REGISTER_SUBMIT_REQUEST});
    try {
        await accountService.register(data);
        history.push('/login');
        return dispatch({type: REGISTER_SUBMIT_SUCCESS});
    } catch (error) {
        return dispatch({type: REGISTER_SUBMIT_FAILURE, error, [no401redirectAttribute]: true});
    }
};

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const onResetPassword = (data, history) => async (dispatch) => {
    dispatch({type: RESET_PASSWORD_REQUEST});
    try {
        await accountService.resetPassword(data);
        history.push('/login');
        return dispatch({type: RESET_PASSWORD_SUCCESS});
    } catch (error) {
        return dispatch({type: RESET_PASSWORD_FAILURE, error, [no401redirectAttribute]: true});
    }
};

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const onForgotPassword = (data, history) => async (dispatch) => {
    dispatch({type: FORGOT_PASSWORD_REQUEST});
    try {
        await accountService.forgotPassword(data);
        history.push('/login');
        return dispatch({type: FORGOT_PASSWORD_SUCCESS});
    } catch (error) {
        return dispatch({type: FORGOT_PASSWORD_FAILURE, error, [no401redirectAttribute]: true});
    }
};

export const SEND_FEEDBACK_REQUEST = 'SEND_FEEDBACK_REQUEST';
export const SEND_FEEDBACK_SUCCESS = 'SEND_FEEDBACK_SUCCESS';
export const SEND_FEEDBACK_FAILURE = 'SEND_FEEDBACK_FAILURE';


export const onSendFeedback = (data, successNotification, onSuccess) => async (dispatch) => {
    dispatch({type: SEND_FEEDBACK_REQUEST});
    try {
        await accountService.sendFeedback(data);
        if (onSuccess) {
            onSuccess();
        }
        return dispatch({type: SEND_FEEDBACK_SUCCESS, successNotification});
    } catch (error) {
        console.error(error);
        return dispatch({type: SEND_FEEDBACK_FAILURE, error, errorNotification: 'An error occurred when sending your feedback. Please try again later'});
    }
};



// WEBPACK FOOTER //
// ./src/actions/AccountActions.js